// extracted by mini-css-extract-plugin
export default {"bp-small":"768px","hamburger":"Hamburger-module__hamburger___gw6Jq","welcome":"Hamburger-module__welcome___Ex8g-"};